import React from 'react'
import { Text } from '@dd3tech/wiggui/Text'

interface IProps {
  label: string
  icon: React.ReactNode
  onClick(): void
}

const ItemShare = ({ label, icon, onClick }: IProps) => {
  return (
    <div className="flex flex-col justify-center gap-2 items-center">
      <div
        className="w-[48px] h-[48px] bg-overlay-white hover:bg-[#00000021] active:bg-[#00000054] rounded-full flex justify-center items-center cursor-pointer"
        onClick={onClick}
      >
        {icon}
      </div>
      <Text as="p" className="text-body-m text-primary">
        {label}
      </Text>
    </div>
  )
}

export default ItemShare
